<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col>
          <h1 class="mt-n5">{{ $t('Asphalt deliveries')}}</h1>
        </v-col>
      </v-row>
      <v-row>
          <v-btn class="ml-3 mt-2 mr-3" :loading="loading" color="primary" @click="refresh"><v-icon>search</v-icon>{{$t('Search')}}</v-btn>
          <v-menu
            ref="menuFrom"
            v-model="menuFrom"
            :return-value.sync="filters.DateFrom"
            transition="scale-transition"
            offset-y
            min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field
                class="ml-3 mr-3"
                v-model="filters.DateFrom"
                :label="$t('Earliest load date')"
                append-icon="event"
                hide-details
                v-on="on"
                @change="dateFromChanged"
                @focus="loading=false">
              </v-text-field>
            </template>
            <v-date-picker
              first-day-of-week="1"
              locale-first-day-of-year="4"
              :show-week="true"
              v-model="filters.DateFrom"
              no-title
              scrollable
              @input="$refs.menuFrom.save(filters.DateFrom)"
              @change="dateFromChanged">
            </v-date-picker>
          </v-menu>
          <v-menu
            ref="menuTo"
            v-model="menuTo"
            :return-value.sync="filters.DateTo"
            transition="scale-transition"
            offset-y
            min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field
                class="ml-3 mr-3"
                v-model="filters.DateTo"
                :label="$t('Latest load date')"
                append-icon="event"
                hide-details
                v-on="on"
                @change="dateToChanged"
                @focus="loading=false">
              </v-text-field>
            </template>
            <v-date-picker
              :first-day-of-week="1"
              :locale-first-day-of-year="4"
              :show-week="true"
              v-model="filters.DateTo"
              no-title
              scrollable
              @input="$refs.menuTo.save(filters.DateTo)"
              @change="dateToChanged">
            </v-date-picker>
          </v-menu>
          <v-text-field class="ml-2 mr-2"
              v-model="filters.AgreementNo"
              append-icon="mdi-magnify"
              :label="$t('Agreement')"
              solo
              hide-details
              shrink
            ></v-text-field>
          <v-flex grow></v-flex>
          <v-flex grow></v-flex>
          <v-flex shrink>
            <v-select class="ml-3 mr-4" :items="facilitiesDisplay" v-model="facilityDisplay" @change="facilityChanged" :label="$t('Facility')"></v-select>
          </v-flex>
      </v-row>
      <v-progress-linear v-if="loading" class="mt-2" :indeterminate="true"></v-progress-linear>
      <v-row v-else v-for="delivery in deliveries" :key="delivery.Id">
        <v-col cols="12">
          <v-card>
            <Delivery :delivery="delivery"></Delivery>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn :to="{name: 'viewAsphalt-delivery', params: {id: delivery}}" color="primary">{{$t("Open")}}</v-btn>
              <v-btn v-if="!isVehicleUser" :to="{name: 'editAsphalt-delivery', params: {id: delivery}}" color="primary">{{$t("Edit")}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import Delivery from '@/modules/asphalt-delivery/components/Delivery'
import * as LocalStorage from '@/core/local-storage'
import { loadFacilities } from '@/core/archive'
import { loadDeliveries, isVehicleUser } from '@/modules/asphalt-delivery/asphalt-delivery'
import moment from 'moment'
import * as Security from '@/core/security'
import _ from 'lodash' // clone

export default {
  components: {
    Delivery
  },
  data () {
    return {
      menuFrom: false,
      menuTo: false,
      filters: {
        DateFrom: moment().format('YYYY-MM-DD'),
        DateTo: moment().format('YYYY-MM-DD'),
        AgreementNo: ''
      },
      loading: false,
      deliveries: [],
      facilityNo: null,
      facilities: null,
      facilitiesDescription: [],
      facilityDescription: '',
      useFacilityDescription: false,
      facilityDisplay: '',
      facilitiesDisplay: [],
      isVehicleUser: false,
      userName: ''
    }
  },
  methods: {
    async refresh () {
      this.loadAsphaltDeliveries()
    },

    async loadAsphaltDeliveries () {
      this.loading = true
      this.deliveries = []
      const params = { facility: this.facilityNo, dateTimeEarliest: this.filters.DateFrom, dateTimeLatest: this.filters.DateTo, agreementNo: this.filters.AgreementNo }
      const deliveriesRes = await loadDeliveries(params)

      // Fix: deliveriesRes.failed does not exist and will result in error on Safari 12.5.2 browser
      if (deliveriesRes && deliveriesRes.length) {
        // Add all VehiclesNum to deliveries
        if (!this.isVehicleUser) {
          // Fix: .Data1.replaceAll() will result in error on Safari 12.5.2 browser. We use .split('x').join('') instead
          this.deliveries = deliveriesRes.map(obj => ({ ...obj, VehiclesNum: obj.Details.find(o => o.Name === 'ValidVehicles')?.Data1.split('[').join('').split(']').join('').split(',') ?? [] }))
        } else {
          const vehicleNum = this.userName.split('.', 2)[1] // Always "SVS.AA00001" etc.
          this.deliveries = deliveriesRes.map(obj => ({ ...obj, VehiclesNum: obj.Details.find(o => o.Name === 'ValidVehicles')?.Data1.includes(vehicleNum) ? [vehicleNum] : [] }))
          this.deliveries = this.deliveries.filter(d => d.DeleteDate !== null)
        }
      }
      this.loading = false
    },

    async facilityChanged () {
      if (this.useFacilityDescription) {
        var facilityDisplay = this.facilitiesDisplay.find(f => f.value === this.facilityDisplay)
        if (facilityDisplay != null) {
          this.facilityNo = facilityDisplay.item.No
        }
      } else {
        this.facilityNo = this.facilityDisplay
      }
      if (this.facilityNo != null) LocalStorage.save('facilityNo', this.facilityNo)
      this.loadAsphaltDeliveries()
    },

    async dateFromChanged () {
      if (!moment(this.filters.DateFrom).isValid()) {
        this.filters.DateFrom = moment().format('YYYY-MM-DD')
      } else {
        if (moment(this.filters.DateFrom).isAfter(moment(this.filters.DateTo))) {
          this.filters.DateTo = moment(this.filters.DateFrom).format('YYYY-MM-DD')
        }
      }
      LocalStorage.save('DateFrom', this.filters.DateFrom)
      LocalStorage.save('DateTo', this.filters.DateTo)
    },

    async dateToChanged () {
      if (!moment(this.filters.DateTo).isValid()) {
        this.filters.DateTo = moment().format('YYYY-MM-DD')
      } else {
        if (moment(this.filters.DateTo).isBefore(moment(this.filters.DateFrom))) {
          this.filters.DateFrom = moment(this.filters.DateTo).format('YYYY-MM-DD')
        }
      }
      LocalStorage.save('DateFrom', this.filters.DateFrom)
      LocalStorage.save('DateTo', this.filters.DateTo)
    }

  },
  async mounted () {
    var noValue = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === undefined ?? false
    if (noValue) {
      this.useFacilityDescription = false
    } else {
      this.useFacilityDescription = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === 'true' ?? false
    }
    const storedDateFrom = LocalStorage.load('DateFrom')
    if (storedDateFrom && moment(storedDateFrom).isValid()) this.filters.DateFrom = storedDateFrom
    else {
      this.filters.DateFrom = moment().format('YYYY-MM-DD')
      LocalStorage.remove('DateFrom')
    }
    const storedDateTo = LocalStorage.load('DateTo')
    if (storedDateTo && moment(storedDateTo).isValid()) this.filters.DateTo = storedDateTo
    else {
      this.filters.DateTo = moment().format('YYYY-MM-DD')
      LocalStorage.remove('DateTo')
    }

    // check if user is a VehicleUser ie. member of "VehicleUsers" group (user must create this hardcoded "VehicleUsers" usergroup)
    const isVehicleUserRes = await isVehicleUser()
    if (!isVehicleUserRes.failed) {
      this.isVehicleUser = isVehicleUserRes.data.isVehicleUser
      this.userName = isVehicleUserRes.data.userName
    }

    const facilitiesRes = await loadFacilities()
    const facilitiesResDescription = _.cloneDeep(facilitiesRes)
    if (!facilitiesRes.failed) {
      if (!facilitiesRes.data.includes('')) facilitiesRes.data.unshift({ No: '', Name: '' })
      this.facilities = facilitiesRes.data.map(item => {
        return {
          text: item.No,
          value: item.No,
          item: item
        }
      })
      this.facilitiesDisplay = this.facilities
      if (this.useFacilityDescription) {
      // const facilitiesRes2 = await Archive.loadFacilities()
        var d = facilitiesResDescription.data
        if (!d.includes('')) d.unshift({ No: '', Description: '' })
        this.facilitiesDescription = d.map(item => {
          return {
            text: item.Description,
            value: item.Description,
            item: item
          }
        })

        this.facilitiesDisplay = this.facilitiesDescription
      }
    }

    const storedFacilityNo = '' + LocalStorage.load('facilityNo')
    if (storedFacilityNo && this.facilities.some(e => e.item.No === storedFacilityNo)) {
      this.facilityNo = storedFacilityNo
      this.facilityDisplay = this.facilityNo
    } else {
      this.facilityNo = null
      LocalStorage.remove('facilityNo')
    }
    if (this.useFacilityDescription) {
      if (this.facilityNo == null) { this.facilityNo = '' }
      this.facilityDisplay = this.facilitiesDescription.find(f => f.item.No === this.facilityNo).value
    } else {
      if (this.facilityNo == null) { this.facilityNo = '' }
      this.facilityDisplay = this.facilities.find(f => f.item.No === this.facilityNo).value
    }
  }
}
</script>
